import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import content from 'content.json';

function Calculation() {
  return (
    <div className="content">
      <Row>
        <Col md="10">
          <Card>
            <CardBody>
              <div style={{ padding: '16px 8px' }}>
                <h1 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>
                  <i className="fas fa-calculator" style={{ color: 'var(--airiq-teal)', marginRight: '12px' }}></i>
                  Average PPM Value During the Night
                </h1>
                
                <p>
                  Our app calculates the weighted average of the measured PPM (parts per million) values 
                  over the nighttime, from <strong style={{ color: 'var(--airiq-teal)' }}>22:00</strong> to <strong style={{ color: 'var(--airiq-teal)' }}>07:00</strong>. 
                  Every 5 minutes during this period, we measure the PPM level in the selected room, 
                  resulting in a total of <strong style={{ color: 'var(--airiq-teal)' }}>108 measurements</strong> throughout the night.
                </p>

                {/* Timeline Visualization */}
                <div style={{ 
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  margin: '32px 0', padding: '20px', 
                  background: 'rgba(255,255,255,0.03)', borderRadius: '12px',
                  border: '1px solid rgba(255,255,255,0.06)'
                }}>
                  <span style={{ color: 'var(--airiq-teal)', fontWeight: 700, fontSize: '1.1rem' }}>22:00</span>
                  <div style={{ flex: 1, height: '4px', background: 'linear-gradient(90deg, var(--airiq-teal), var(--airiq-cyan))', borderRadius: '2px', position: 'relative' }}>
                    {[...Array(9)].map((_, i) => (
                      <div key={i} style={{ 
                        position: 'absolute', top: '-4px', left: `${(i + 1) * 10}%`,
                        width: '6px', height: '12px', borderRadius: '3px',
                        background: 'var(--airiq-teal)', opacity: 0.6
                      }}></div>
                    ))}
                  </div>
                  <span style={{ color: 'var(--airiq-cyan)', fontWeight: 700, fontSize: '1.1rem' }}>07:00</span>
                </div>

                <p>
                  Since each value is collected at equal time intervals (every 5 minutes), they all 
                  contribute equally to the final result. This means that our weighted average is 
                  effectively the same as calculating the simple average of all the PPM values collected.
                </p>

                {/* Formula Box */}
                <div className="formula-box">
                  <p style={{ color: 'var(--airiq-text-muted)', marginBottom: '12px', fontSize: '0.9rem' }}>Weighted Average Formula</p>
                  <strong>
                    Weighted Average = (P<sub>1</sub> + P<sub>2</sub> + ... + P<sub>108</sub>) / 108
                  </strong>
                </div>

                <p>
                  Here, P<sub>1</sub>, P<sub>2</sub>, ..., P<sub>108</sub> represent the PPM values 
                  measured every 5 minutes from 22:00 to 07:00. This average PPM level helps you 
                  quickly assess the air quality in your room overnight, allowing you to identify 
                  any trends or potential issues.
                </p>

                <div style={{ 
                  marginTop: '24px', padding: '16px 20px', borderRadius: '8px',
                  background: 'rgba(0, 212, 170, 0.06)', border: '1px solid rgba(0, 212, 170, 0.15)'
                }}>
                  <p style={{ margin: 0, fontSize: '0.9rem' }}>
                    <i className="fas fa-info-circle" style={{ color: 'var(--airiq-teal)', marginRight: '8px' }}></i>
                    <strong style={{ color: 'var(--airiq-text-primary)' }}>Tip:</strong> A lower PPM value generally indicates better air quality, 
                    while higher values may suggest poor ventilation or increased pollutant levels.
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Calculation;
